import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { IMAGES, WHY_CHOOSE } from "@/data/site";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={IMAGES.about}
                alt="CWood Construction premium patio work"
                className="w-full h-[460px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 hidden sm:block bg-[#1656b8] text-white rounded-2xl p-6 shadow-xl">
              <div className="font-heading text-4xl font-extrabold">100%</div>
              <div className="text-sm text-blue-100 mt-1">Quality Guaranteed</div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-sm text-[#1656b8] uppercase tracking-[0.2em] font-semibold">
              About Us
            </span>
            <h2 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight mt-3">
              A construction team you can genuinely trust
            </h2>
            <p className="mt-5 text-slate-600 leading-relaxed">
              We are a fully qualified construction team based in West Yorkshire,
              delivering high-quality workmanship across all aspects of building and
              landscaping.
            </p>
            <p className="mt-4 text-slate-600 leading-relaxed">
              Whether it's a new patio, garden renovation, retaining wall, brickwork
              project or complete outdoor transformation, we take pride in providing
              reliable service, excellent attention to detail and lasting results.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              {WHY_CHOOSE.map((item, i) => (
                <div
                  key={i}
                  data-testid={`why-choose-${i}`}
                  className="flex items-center gap-3"
                >
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#1656b8] flex items-center justify-center">
                    <Check size={14} className="text-white" strokeWidth={3} />
                  </span>
                  <span className="text-slate-800 font-medium text-sm">{item}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
